import { Navigate, useParams } from 'react-router';

import { NotFoundPage } from '@/app/shell/NotFoundPage';
import { buildLegacyCreateIncidentUrl } from './legacyUrls';

export function LegacyCreateIncidentRedirect() {
  const { id, phoneNumber } = useParams();
  const createIncidentUrl = buildLegacyCreateIncidentUrl(phoneNumber, id);

  if (createIncidentUrl === null) {
    return <NotFoundPage />;
  }

  return <Navigate to={createIncidentUrl} replace />;
}
